// frontend/src/App.js
import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TeamLogin from './components/TeamLogin';
import Map from './components/Map';
import BackgroundPattern from './components/BackgroundPattern';
import './styles.css';

function App() {
  const [team, setTeam] = useState(null);
  const [loading, setLoading] = useState(true);

  // Проверка сессии при загрузке
  useEffect(() => {
    const sessionKey = localStorage.getItem('teamSessionKey');
    if (sessionKey) {
      verifySession(sessionKey);
    } else {
      setLoading(false);
    }
  }, []);

  const verifySession = async (sessionKey) => {
    try {
      const response = await fetch('https://pro-mashrutssla.ru/api/team/verify/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ session_key: sessionKey }),
      });
      
      if (response.ok) {
        const data = await response.json();
        setTeam({ 
          id: data.team_id,
          name: data.team_name, 
          code: data.team_code,
          sessionKey 
        });
      } else {
        // Сессия недействительна, удаляем из localStorage
        localStorage.removeItem('teamSessionKey');
      }
    } catch (error) {
      console.error('Session verification failed:', error);
      localStorage.removeItem('teamSessionKey');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p>Загрузка...</p>
      </div>
    );
  }

  return (
    <div className="app">
      <BackgroundPattern />
      <Routes>
        <Route 
          path="/" 
          element={team ? <Navigate to="/map" /> : <Navigate to="/login" />} 
        />
        <Route 
          path="/login" 
          element={<TeamLogin setTeam={setTeam} />} 
        />
        <Route 
          path="/map" 
          element={team ? <Map team={team} /> : <Navigate to="/login" />} 
        />
      </Routes>
    </div>
  );
}

export default App;